import React from 'react';

const Redirect = () => {
  React.useEffect(() => {
    const { href } = window.location;
    const legacyHref = href.replace('/app/', '/legacy/');
    window.location.replace(legacyHref);
  });

  return null;
};

export default Redirect;
